import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Alert,
  Paper,
  Divider,
  Chip,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemSecondary,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import {
  Close as CloseIcon,
  Send as SendIcon,
  Refresh as RefreshIcon,
  WebhookOutlined,
  Add as AddIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';
import api from '../../utils/api';
import axios from 'axios';
import WebhookLogsViewer from './WebhookLogsViewer';

// Eventi disponibili per il test
const AVAILABLE_EVENTS = [
  { type: 'maintenance.status_changed', label: 'Cambio Stato Manutenzione (Tutti gli stati)' },
  { type: 'maintenance.created', label: 'Nuova Manutenzione' },
  { type: 'maintenance.queued', label: 'Manutenzione In Coda' },
  { type: 'maintenance.in_progress', label: 'Manutenzione In Corso' },
  { type: 'maintenance.waiting_parts', label: 'Manutenzione in Attesa Ricambi' },
  { type: 'maintenance.waiting_customer', label: 'Manutenzione in Attesa Cliente' },
  { type: 'maintenance.ready_to_call', label: 'Manutenzione Da Chiamare' },
  { type: 'maintenance.ready_for_pickup', label: 'Manutenzione Da Ritirare' },
  { type: 'maintenance.reminded', label: 'Manutenzione Sollecitata' },
  { type: 'maintenance.parked', label: 'Manutenzione in Parcheggio' },
  { type: 'maintenance.completed', label: 'Manutenzione Consegnata' },
  { type: 'sale.created', label: 'Nuova Vendita' },
  { type: 'sale.status_changed', label: 'Cambio Stato Vendita' },
  { type: 'sale.deleted', label: 'Vendita Eliminata' },
  { type: 'order.created', label: 'Nuovo Ordine' },
  { type: 'order.updated', label: 'Ordine Aggiornato' },
  { type: 'order.deleted', label: 'Ordine Eliminato' },
  { type: 'product.created', label: 'Nuovo Prodotto' },
  { type: 'product.updated', label: 'Prodotto Aggiornato' },
  { type: 'product.deleted', label: 'Prodotto Eliminato' },
  { type: 'document.created', label: 'Nuovo Documento' },
  { type: 'document.updated', label: 'Documento Aggiornato' },
  { type: 'document.deleted', label: 'Documento Eliminato' },
  { type: 'document.signed', label: 'Documento Firmato' },
  { type: 'document.shared', label: 'Documento Condiviso' },
  { type: 'invoice.created', label: 'Nuova Fattura' },
  { type: 'invoice.paid', label: 'Fattura Pagata' },
  { type: 'invoice.overdue', label: 'Fattura Scaduta' },
  { type: 'invoice.cancelled', label: 'Fattura Annullata' },
  { type: 'user.created', label: 'Nuovo Utente' },
  { type: 'user.updated', label: 'Utente Aggiornato' },
  { type: 'user.deleted', label: 'Utente Eliminato' },
  { type: 'user.login', label: 'Login Utente' },
  { type: 'user.logout', label: 'Logout Utente' },
  { type: 'system.backup', label: 'Backup Sistema' },
  { type: 'system.error', label: 'Errore Sistema' },
  { type: 'system.maintenance', label: 'Manutenzione Sistema' },
  { type: 'system.update', label: 'Aggiornamento Sistema' }
];

// Raggruppa gli eventi per categoria
const EVENT_GROUPS = {
  maintenance: {
    label: 'Manutenzioni',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('maintenance.'))
  },
  sale: {
    label: 'Vendite',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('sale.'))
  },
  order: {
    label: 'Ordini',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('order.'))
  },
  product: {
    label: 'Prodotti',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('product.'))
  },
  document: {
    label: 'Documenti',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('document.'))
  },
  invoice: {
    label: 'Fatture',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('invoice.'))
  },
  user: {
    label: 'Utenti',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('user.'))
  },
  system: {
    label: 'Sistema',
    events: AVAILABLE_EVENTS.filter(e => e.type.startsWith('system.'))
  }
};

const EVENT_LABELS = {};
AVAILABLE_EVENTS.forEach(event => {
  EVENT_LABELS[event.type] = event.label;
});

const WebhookTester = ({ open, onClose, mode = 'production' }) => {
  const [selectedEvent, setSelectedEvent] = useState('maintenance.created');
  const [selectedWebhook, setSelectedWebhook] = useState('');
  const [webhooks, setWebhooks] = useState([]);
  const [testData, setTestData] = useState({
    customerName: 'Mario Rossi',
    customerEmail: 'mario@example.com',
    description: 'Manutenzione ordinaria',
    bikeModel: 'Mountain Bike'
  });
  const [loading, setLoading] = useState(false);
  const [loadingWebhooks, setLoadingWebhooks] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const [testScenario, setTestScenario] = useState('success');
  const [showAddWebhook, setShowAddWebhook] = useState(false);
  const [newWebhook, setNewWebhook] = useState({
    name: '',
    url: '',
    events: [],
    isActive: true
  });
  const [selectedEvents, setSelectedEvents] = useState({});
  const [showTestForm, setShowTestForm] = useState(false);
  const [testEvent, setTestEvent] = useState('');
  const [testPayload, setTestPayload] = useState('');
  const [testResult, setTestResult] = useState(null);
  const [showLogs, setShowLogs] = useState(false);
  const [selectedWebhookForLogs, setSelectedWebhookForLogs] = useState(null);

  // Carica i webhook dal localStorage all'avvio
  useEffect(() => {
    if (open && mode === 'production') {
      const savedWebhooks = localStorage.getItem('webhooks');
      if (savedWebhooks) {
        setWebhooks(JSON.parse(savedWebhooks));
      }
      loadWebhooks();
    }
  }, [open, mode]);

  // Salva i webhook nel localStorage quando cambiano
  useEffect(() => {
    if (webhooks.length > 0) {
      localStorage.setItem('webhooks', JSON.stringify(webhooks));
    }
  }, [webhooks]);

  const loadWebhooks = async () => {
    try {
      setLoadingWebhooks(true);
      const response = await api.get('/webhooks');
      console.log('🔍 Webhook caricati per il tester:', response.data);
      setWebhooks(response.data);
      localStorage.setItem('webhooks', JSON.stringify(response.data));
    } catch (error) {
      console.error('❌ Errore nel caricamento dei webhook:', error);
      setError('Errore nel caricamento dei webhook');
    } finally {
      setLoadingWebhooks(false);
    }
  };

  const handleEventChange = (e) => {
    setSelectedEvent(e.target.value);
  };

  const handleWebhookChange = (e) => {
    setSelectedWebhook(e.target.value);
  };

  const handleDataChange = (e) => {
    const { name, value } = e.target;
    setTestData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGroupSelect = (group, checked) => {
    const groupEvents = EVENT_GROUPS[group].events.map(e => e.type);
    const newSelectedEvents = { ...selectedEvents };
    
    groupEvents.forEach(event => {
      newSelectedEvents[event] = checked;
    });
    
    setSelectedEvents(newSelectedEvents);
    setNewWebhook(prev => ({
      ...prev,
      events: checked 
        ? [...new Set([...prev.events, ...groupEvents])]
        : prev.events.filter(e => !groupEvents.includes(e))
    }));
  };

  const handleEventSelect = (eventType, checked) => {
    setSelectedEvents(prev => ({
      ...prev,
      [eventType]: checked
    }));
    
    setNewWebhook(prev => ({
      ...prev,
      events: checked
        ? [...prev.events, eventType]
        : prev.events.filter(e => e !== eventType)
    }));
  };

  const handleSelectAllEvents = (checked) => {
    const allEvents = AVAILABLE_EVENTS.map(e => e.type);
    const newSelectedEvents = {};
    
    allEvents.forEach(eventType => {
      newSelectedEvents[eventType] = checked;
    });
    
    setSelectedEvents(newSelectedEvents);
    setNewWebhook(prev => ({
      ...prev,
      events: checked ? allEvents : []
    }));
  };

  const handleAddWebhook = async () => {
    try {
      setLoading(true);
      setError(null);

      // Assicuriamoci che events sia sempre un array
      const webhookToSend = {
        ...newWebhook,
        events: Array.isArray(newWebhook.events) ? newWebhook.events : []
      };

      if (!webhookToSend.name || !webhookToSend.url || webhookToSend.events.length === 0) {
        setError('Nome, URL ed almeno un evento sono richiesti');
        return;
      }

      console.log('Invio webhook con eventi:', webhookToSend.events);
      const response = await api.post('/webhooks', webhookToSend);
      console.log('✅ Webhook creato:', response.data);
      
      // Aggiorna la lista
      const updatedWebhooks = [...webhooks, response.data.webhook];
      setWebhooks(updatedWebhooks);
      localStorage.setItem('webhooks', JSON.stringify(updatedWebhooks));
      
      // Reset form
      setNewWebhook({
        name: '',
        url: '',
        events: [],
        isActive: true
      });
      setSelectedEvents({});
      setShowAddWebhook(false);
    } catch (err) {
      console.error('❌ Errore nella creazione del webhook:', err);
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteWebhook = async (webhookId) => {
    try {
      setLoading(true);
      await api.delete(`/webhooks/${webhookId}`);
      
      // Aggiorna la lista
      const updatedWebhooks = webhooks.filter(w => w.id !== webhookId);
      setWebhooks(updatedWebhooks);
      localStorage.setItem('webhooks', JSON.stringify(updatedWebhooks));
    } catch (err) {
      setError('Errore nell\'eliminazione del webhook');
    } finally {
      setLoading(false);
    }
  };

  const handleTestEvent = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      if (mode === 'local') {
        // Test locale usando il mock receiver
        if (!selectedEvent) {
          throw new Error('Seleziona un evento da testare');
        }

        const response = await axios.post('/api/webhooks/test', {
          event: selectedEvent,
          url: 'http://localhost:5000/api/webhooks/mock-receiver', // URL del mock receiver
          scenario: testScenario,
          payload: {
            ...testData,
            testId: Date.now(),
            timestamp: new Date().toISOString()
          }
        });

        setResult(response.data);
      } else {
        // Test in produzione usando i webhook configurati
        console.log('Test webhook con ID:', selectedWebhook); 
        const webhookObj = webhooks.find(w => w.id === selectedWebhook);
        console.log('Webhook selezionato:', webhookObj?.name, webhookObj?.url);
        
        const response = await api.post('/webhooks/test', {
          event: selectedEvent,
          webhookId: selectedWebhook || undefined,
          payload: {
            ...testData,
            testId: Date.now(),
            timestamp: new Date().toISOString()
          }
        });

        setResult(response.data);
      }
    } catch (err) {
      console.error('❌ Errore nel test:', err);
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  // Filtra i webhook che supportano l'evento selezionato
  const getCompatibleWebhooks = () => {
    if (!selectedEvent) return [];

    return webhooks.filter(webhook => 
      webhook.events && webhook.events.includes(selectedEvent)
    );
  };

  const compatibleWebhooks = getCompatibleWebhooks();

  const isGroupSelected = (group) => {
    const groupEvents = EVENT_GROUPS[group].events.map(e => e.type);
    return groupEvents.every(eventType => selectedEvents[eventType]);
  };

  const isGroupIndeterminate = (group) => {
    const groupEvents = EVENT_GROUPS[group].events.map(e => e.type);
    const selectedCount = groupEvents.filter(eventType => selectedEvents[eventType]).length;
    return selectedCount > 0 && selectedCount < groupEvents.length;
  };

  const areAllEventsSelected = () => {
    return AVAILABLE_EVENTS.every(event => selectedEvents[event.type]);
  };

  const renderWebhookList = () => (
    <List>
      {webhooks.map((webhook) => (
        <ListItem
          key={webhook.id}
          divider
          secondaryAction={
            <Box sx={{ display: 'flex' }}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setSelectedWebhookForLogs(webhook.id);
                  setShowLogs(true);
                }}
                sx={{ mr: 1 }}
              >
                Log
              </Button>
              <IconButton onClick={() => handleDeleteWebhook(webhook.id)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          }
        >
          <ListItemText
            primary={webhook.name}
            secondary={
              <>
                <Typography component="span" variant="body2" color="text.primary">
                  {webhook.url}
                </Typography>
                <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {webhook.events.map((event) => (
                    <Chip
                      key={event}
                      label={EVENT_LABELS[event] || event}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  ))}
                </Box>
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  );

  const handleTest = async () => {
    try {
      if (!testEvent) {
        setTestResult({
          success: false,
          message: 'Seleziona un evento da testare'
        });
        return;
      }
      
      let testData;
      try {
        testData = testPayload ? JSON.parse(testPayload) : {};
      } catch (e) {
        setTestResult({
          success: false,
          message: 'Errore nel parsing del JSON: ' + e.message
        });
        return;
      }
      
      const webhookObj = webhooks.find(w => w.id === selectedWebhook);
      console.log('Test webhook:', webhookObj ? `ID: ${webhookObj.id}, URL: ${webhookObj.url}` : 'Nessun webhook selezionato');
      
      const response = await fetch('/api/webhooks/test', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          event: testEvent,
          webhookId: selectedWebhook,
          scenario: testScenario,
          payload: testData
        })
      });

      const result = await response.json();
      setTestResult(result);
    } catch (error) {
      setTestResult({
        success: false,
        message: 'Errore durante il test',
        error: error.message
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SendIcon sx={{ mr: 1 }} />
          <Typography variant="h6">
            {mode === 'local' ? 'Test Webhook Locale' : 'Gestione Webhook'}
          </Typography>
          {mode === 'local' && (
            <Chip 
              label="Local" 
              color="secondary" 
              size="small" 
              sx={{ ml: 1 }} 
            />
          )}
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {mode === 'production' && !showAddWebhook && (
          <>
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="body1">
                Gestisci i webhook configurati o aggiungine di nuovi.
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setShowAddWebhook(true)}
              >
                Nuovo Webhook
              </Button>
            </Box>
            {renderWebhookList()}
          </>
        )}

        {mode === 'production' && showAddWebhook && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Nuovo Webhook
            </Typography>
            
            <TextField
              fullWidth
              label="Nome"
              value={newWebhook.name}
              onChange={(e) => setNewWebhook(prev => ({ ...prev, name: e.target.value }))}
              margin="normal"
            />

            <TextField
              fullWidth
              label="URL"
              value={newWebhook.url}
              onChange={(e) => setNewWebhook(prev => ({ ...prev, url: e.target.value }))}
              margin="normal"
              helperText="Es: https://webhook.site/..."
            />

            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Eventi
              </Typography>
              
              <FormControlLabel
                control={
                  <Checkbox
                    checked={areAllEventsSelected()}
                    indeterminate={!areAllEventsSelected() && Object.values(selectedEvents).some(Boolean)}
                    onChange={(e) => handleSelectAllEvents(e.target.checked)}
                  />
                }
                label="Seleziona tutti"
              />

              {Object.entries(EVENT_GROUPS).map(([group, { label, events }]) => (
                <Box key={group} sx={{ ml: 2, mb: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isGroupSelected(group)}
                        indeterminate={isGroupIndeterminate(group)}
                        onChange={(e) => handleGroupSelect(group, e.target.checked)}
                      />
                    }
                    label={label}
                  />
                  
                  <Box sx={{ ml: 4 }}>
                    <Grid container spacing={1}>
                      {events.map((event) => (
                        <Grid item xs={12} sm={6} key={event.type}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedEvents[event.type] || false}
                                onChange={(e) => handleEventSelect(event.type, e.target.checked)}
                                size="small"
                              />
                            }
                            label={event.label}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              ))}
            </Box>

            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                onClick={() => {
                  setShowAddWebhook(false);
                  setSelectedEvents({});
                }}
              >
                Annulla
              </Button>
              <Button
                variant="contained"
                onClick={handleAddWebhook}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} /> : null}
              >
                Crea Webhook
              </Button>
            </Box>
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 3, px: 2, py: 1 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              {error}
            </Typography>
          </Alert>
        )}

        {result && (
          <Alert 
            severity={result.success ? "success" : "error"}
            sx={{ mb: 3, px: 2, py: 1 }}
            onClose={() => setResult(null)}
          >
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              {result.message}
            </Typography>
            {result.details && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                {result.details}
              </Typography>
            )}
          </Alert>
        )}

        <FormControl fullWidth margin="normal">
          <InputLabel>Evento</InputLabel>
          <Select
            value={selectedEvent}
            onChange={handleEventChange}
            label="Evento"
          >
            {AVAILABLE_EVENTS.map((event) => (
              <MenuItem key={event.type} value={event.type}>
                {event.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {mode === 'production' && selectedEvent && (
          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel id="webhook-select-label">Webhook da Testare (opzionale)</InputLabel>
            <Select
              labelId="webhook-select-label"
              value={selectedWebhook}
              onChange={handleWebhookChange}
              label="Webhook da Testare (opzionale)"
              disabled={loadingWebhooks}
            >
              <MenuItem value="">
                <em>Tutti i webhook compatibili</em>
              </MenuItem>
              {compatibleWebhooks.map((webhook) => (
                <MenuItem key={webhook.id} value={webhook.id}>
                  {webhook.name || 'Webhook senza nome'} - {webhook.url}
                </MenuItem>
              ))}
            </Select>
            <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
              {selectedWebhook 
                ? `L'evento verrà inviato al webhook: ${webhooks.find(w => w.id === selectedWebhook)?.url || ''}` 
                : compatibleWebhooks.length > 0 
                  ? `L'evento verrà inviato a ${compatibleWebhooks.length} webhook compatibili` 
                  : 'Nessun webhook registrato per questo evento'}
            </Typography>
          </FormControl>
        )}

        {mode === 'local' && (
          <FormControl fullWidth margin="normal">
            <InputLabel>Scenario di Test</InputLabel>
            <Select
              value={testScenario}
              onChange={(e) => setTestScenario(e.target.value)}
              label="Scenario di Test"
            >
              <MenuItem value="success">Successo</MenuItem>
              <MenuItem value="error">Errore Server</MenuItem>
              <MenuItem value="rateLimited">Rate Limit</MenuItem>
            </Select>
          </FormControl>
        )}

        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Dati di Test
        </Typography>

        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Nome Cliente"
            name="customerName"
            value={testData.customerName}
            onChange={handleDataChange}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Email Cliente"
            name="customerEmail"
            value={testData.customerEmail}
            onChange={handleDataChange}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Descrizione"
            name="description"
            value={testData.description}
            onChange={handleDataChange}
            margin="normal"
            multiline
            rows={2}
          />

          <TextField
            fullWidth
            label="Modello Bici"
            name="bikeModel"
            value={testData.bikeModel}
            onChange={handleDataChange}
            margin="normal"
          />
        </Box>

        {result && result.success && result.response && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Risposta dal Server
            </Typography>
            <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
              <pre style={{ margin: 0, overflow: 'auto', fontSize: '0.875rem' }}>
                {JSON.stringify(result.response, null, 2)}
              </pre>
            </Paper>
          </Box>
        )}

        {mode === 'production' && selectedEvent && (
          <Button
            variant="contained"
            onClick={() => {
              setSelectedWebhook(null);
              setShowTestForm(true);
            }}
            startIcon={<SendIcon />}
            sx={{
              background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              color: 'white',
              mt: 2
            }}
          >
            Test Webhook
          </Button>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="outlined"
          onClick={() => setTestData({
            customerName: 'Mario Rossi',
            customerEmail: 'mario@example.com',
            description: 'Manutenzione ordinaria',
            bikeModel: 'Mountain Bike'
          })}
          startIcon={<RefreshIcon />}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          onClick={handleTestEvent}
          disabled={loading}
          startIcon={<SendIcon />}
          sx={{
            background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
            color: 'white',
          }}
        >
          {loading ? <CircularProgress size={24} /> : "Invia Evento"}
        </Button>
      </DialogActions>

      <Dialog open={showTestForm} onClose={() => setShowTestForm(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          Test Webhook
          {selectedWebhook && ` - ${selectedWebhook.name}`}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Evento</InputLabel>
                <Select
                  value={testEvent}
                  onChange={(e) => setTestEvent(e.target.value)}
                >
                  {Object.entries(EVENT_GROUPS).map(([group, groupData]) => [
                    <MenuItem key={group} disabled>
                      {groupData.label}
                    </MenuItem>,
                    ...groupData.events.map(event => (
                      <MenuItem key={event.type} value={event.type}>
                        &nbsp;&nbsp;{event.label}
                      </MenuItem>
                    ))
                  ])}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Scenario Test</InputLabel>
                <Select
                  value={testScenario}
                  onChange={(e) => setTestScenario(e.target.value)}
                >
                  <MenuItem value="success">Successo</MenuItem>
                  <MenuItem value="error">Errore Server</MenuItem>
                  <MenuItem value="rateLimited">Rate Limit</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Payload (JSON)"
                multiline
                rows={4}
                value={testPayload}
                onChange={(e) => setTestPayload(e.target.value)}
                margin="normal"
              />
            </Grid>

            {testResult && (
              <Grid item xs={12}>
                <Alert severity={testResult.success ? "success" : "error"}>
                  {testResult.message}
                </Alert>
                <pre style={{ whiteSpace: 'pre-wrap' }}>
                  {JSON.stringify(testResult, null, 2)}
                </pre>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowTestForm(false)}>Chiudi</Button>
          <Button onClick={handleTest} color="primary">
            Invia Test
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog 
        open={showLogs} 
        onClose={() => setShowLogs(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Log Webhook
          <IconButton
            aria-label="close"
            onClick={() => setShowLogs(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <WebhookLogsViewer webhookId={selectedWebhookForLogs} />
        </DialogContent>
      </Dialog>
    </Dialog>
  );
};

export default WebhookTester; 